import { CompleteRegistrationFlowStepKey } from '@/components/flows/CompleteRegistrationFlow/types'

export const GETTING_STARTED_STEP_TITLES: Record<
  CompleteRegistrationFlowStepKey,
  string
> = {
  'company-services': 'What services does your firm offer?',
  'connect-email-and-calendar': 'Connect your email and calendar to RQ',
  'company-expertise-areas': "What are your firm's areas of expertise?",
  'company-office-locations': "Where are your firm's office locations?",
  'company-operating-locations': 'Where does your firm work?',
  'invite-referral-partners': 'Invite your referral partners to RQ',
  'import-historical-referrals': 'Upload your existing referrals data',
  'upload-logo': "Upload your firm's logo",
  'upload-video': 'Share a video about you or your firm',
}

export const GETTING_STARTED_STEP_NAMES: Record<
  CompleteRegistrationFlowStepKey,
  string
> = {
  'company-services': 'List your services',
  'connect-email-and-calendar': 'Connect your email and calendar to RQ',
  'company-expertise-areas': 'Select your areas of expertise',
  'company-office-locations': 'Enter your office locations',
  'company-operating-locations': 'Select where your firm works',
  'invite-referral-partners': 'Invite your referral partners to RQ',
  'import-historical-referrals': 'Upload your existing referrals data',
  'upload-logo': "Upload your firm's logo",
  'upload-video': 'Upload video about your firm',
}
